import log from 'loglevel';
import ApiListDev from '../../resources/json/listOfApi-dev.json';
import ApiListLocal from '../../resources/json/listOfApi-local.json';
import ApiListTest from '../../resources/json/listOfApi-test.json';
import ApiListProd from '../../resources/json/listOfApi-prod.json';

let apiPath;
const appEnv = window.REACT_APP_ENV || process.env.REACT_APP_ENV;

if (appEnv === 'LOCAL') {
    apiPath = ApiListLocal.logs;
} else if (appEnv === 'DEV') {
    apiPath = ApiListDev.logs;
} else if (appEnv === 'TEST') {
    apiPath = ApiListTest.logs;
} else if(appEnv === 'PROD') {
    apiPath = ApiListProd.logs;
} else {
    apiPath = ApiListLocal.logs;
}

// Helper function to decode JWT token
function decodeJWT(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (e) {
        return null;
    }
}

// Helper function to check if token is expired
function isTokenExpired(token) {
    const decoded = decodeJWT(token);
    if (!decoded || !decoded.exp) {
        return true;
    }
    const currentTime = Math.floor(Date.now() / 1000);
    return currentTime >= decoded.exp;
}

// Store the original method factory
const originalMethodFactory = log.methodFactory;

// Override to add remote logging with JWT
log.methodFactory = function (methodName, logLevel, loggerName) {
    const rawMethod = originalMethodFactory(methodName, logLevel, loggerName);

    return function (message) {
        // Log to console
        rawMethod(message);

        // Send to remote with JWT token
        const idToken = localStorage.getItem('idToken');
        
        // Only send if token exists AND is not expired
        if (idToken && !isTokenExpired(idToken)) {
            fetch(apiPath, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${idToken}`
                },
                body: JSON.stringify({
                    message: message,
                    level: methodName,
                    timestamp: new Date().toISOString()
                })
            }).catch(() => {}); // Silent fail
        }
        // If token is expired, skip sending (silent fail)
    };
};

// Apply the new method factory
log.setLevel(log.getLevel());

export default log;